import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Gram, PoundLb } from "./mass";
export var KilogramPerMol = UnitDivide.massByMolarMass("KilogramPerMol", BaseUnits.Kilogram, BaseUnits.Mole);
export var GramPerMol = UnitDivide.massByMolarMass("GramPerMol", Gram, BaseUnits.Mole);
export var PoundLbPerMol = UnitDivide.massByMolarMass("PoundLbPerMol", PoundLb, BaseUnits.Mole);
//# sourceMappingURL=molar-mass.js.map